document.addEventListener('DOMContentLoaded', () => {
  if (document.body.classList.contains('neos-backend')) return;
  const accordions = document.querySelectorAll('.c-accordion');
  if (accordions.length === 0) return;
  accordions.forEach(function (accordion) {
    const entries = accordion.querySelectorAll('.c-accordion-entry');
    entries.forEach(initAccordion);

    accordion.querySelector('.open-all')?.addEventListener('click', (e) => openAll(e, entries));
    accordion.querySelector('.close-all')?.addEventListener('click', (e) => closeAll(e, entries));
  });
});

function openAll(e, entries) {
  e?.preventDefault();
  entries.forEach((item) => {
    if (!item.hasAttribute('open')) {
      item.querySelector('summary')?.click();
    }
  });
}

function closeAll(e, entries) {
  e?.preventDefault();
  entries.forEach((item) => {
    if (item.attributes.open) {
      item.querySelector('summary')?.click();
    }
  });
}

function initAccordion(item) {
  const summary = item.querySelector('summary');
  const content = item.querySelector('.c-accordion-content');
  const accordion = item.closest('.c-accordion');
  let isAnimating = false;

  summary.addEventListener('click', (e) => {
    e.preventDefault();
    if (isAnimating) return;

    const isOpen = item.hasAttribute('open');
    toggle(item, content, accordion, !isOpen);
  });
}

function toggle(item, content, accordion, shouldOpen) {
  const singleOpen = accordion?.dataset.singleOpenAtOnce !== undefined;

  if (shouldOpen && singleOpen) {
    accordion.querySelectorAll('.c-accordion-entry[open]').forEach((i) => {
      if (i !== item) close(i);
    });
  }

  shouldOpen ? open(item, content) : close(item);
}

function open(item, content) {
  item.setAttribute('open', '');
  content.style.height = '0px';
  content.style.overflow = 'hidden';

  const height = content.scrollHeight;

  requestAnimationFrame(() => {
    content.style.transition = 'height 300ms ease';
    content.style.height = height + 'px';
  });

  content.addEventListener('transitionend', function handler() {
    content.style.height = '';
    content.style.overflow = '';
    content.style.transition = '';
    content.removeEventListener('transitionend', handler);
  });
}

function close(item) {
  const content = item.querySelector('.c-accordion-content');
  const height = content.scrollHeight;

  content.style.height = height + 'px';
  content.style.overflow = 'hidden';

  requestAnimationFrame(() => {
    content.style.transition = 'height 300ms ease';
    content.style.height = '0px';
  });

  content.addEventListener('transitionend', function handler() {
    item.removeAttribute('open');
    content.style.height = '';
    content.style.overflow = '';
    content.style.transition = '';
    content.removeEventListener('transitionend', handler);
  });
}
